module.exports = __webpack_public_path__ + "img/Atlassia.147234f.svg";